module.exports = __webpack_public_path__ + "~@/assets/img/image4-compressed.1240aef1.png";